
import { css } from 'lit';
export default css`
:host{
  --carousel-pagination-bottom-complement:0px;

  --carousel-pagination-color:var(--neutral-medium-gray);
  --carousel-pagination-active-color:var(--purple-indigo-light);
}

.carousel.carousel--testimonial{
  background-color:var(--primary-eggplant);
}

.carousel.carousel--testimonial .splide__pagination{
  position:absolute;
  bottom:calc(
    var(--carousel-pagination-bottom-complement) + var(--spacing-8) + 3px
  );
  left:var(--spacing-8);
}

pc-image img{
  max-width:100%;
  width:100%;
  height:auto;
}

@media (min-width: 992px){
  .carousel.carousel--testimonial{
    padding-top:var(--spacing-8);
    padding-bottom:var(--spacing-8);
  }

  .carousel.carousel--testimonial .splide__pagination{
    bottom:calc(
      var(--carousel-pagination-bottom-complement) + var(--spacing-4)
    );
    left:calc(1 / 12 * 100% + var(--spacing-8));
  }

  .carousel.carousel--testimonial
    .carousel--slide-without-image
    .splide__pagination{
    bottom:calc(
      var(--carousel-pagination-bottom-complement) + var(--spacing-4)
    );
    left:calc(2 / 12 * 100% + var(--spacing-8));
  }
}
`;